import React, { ReactNode } from 'react'
import { l } from '@ds/index'
import cx from 'classnames'

import { Feature } from 'common/billing/components/SubscriptionSuccessModal/features'

import { PriceBreakdownList } from '../PriceBreakdownList/PriceBreakdownList'

import cm from './PlanCard.module.css'

interface PlanCardProps {
  title: string
  price: ReactNode
  isPriceMuted?: boolean
  priceNote?: ReactNode
  priceBasis?: ReactNode
  footer?: ReactNode
  isCardHighlighted?: boolean
  className?: string
  features?: Feature[]
  enlargeTitle?: boolean
}

export const PlanCard = ({
  title,
  price,
  priceNote,
  priceBasis,
  footer,
  isCardHighlighted,
  className,
  isPriceMuted,
  features = [],
  enlargeTitle,
}: PlanCardProps) => {
  const topSection = enlargeTitle ? (
    <>
      <p className="m-t-0 text-display-sm">{title}</p>
      <hr className={cx('m-b', cm.divider)} />
      <p className="m-t-0 m-b-xs">
        <b className="text-subheading">{price}</b>
        <span className="text-body-sm m-l-xxs text-secondary">{l.translate('/mo')}</span>
      </p>
    </>
  ) : (
    <>
      <p className="text-heading-sm m-t-0">{title}</p>
      <hr className={cm.divider} />
      <div>
        <b className="text-display-lg">{price}</b>
        <span className="text-body m-l-xxs text-secondary">{l.translate('/mo')}</span>
      </div>
    </>
  )

  const content = (
    <div
      className={cx('p-a d-flex flex-col', cm.root, className, {
        ['text-secondary']: isPriceMuted,
      })}
    >
      {topSection}
      {priceNote}
      {Boolean(priceBasis) && <p className="text-subheading-sm">{priceBasis}</p>}
      {features.length > 0 && (
        <PriceBreakdownList
          className={cx('align-start w-full m-b-auto', cm.featuresList)}
          features={features}
        />
      )}
      {footer}
    </div>
  )

  if (isCardHighlighted) {
    return (
      <div className={cx({ [cm.cardHighlighted]: isCardHighlighted })}>
        <p className="text-center text-white text-body-sm p-y-xxs">{l.translate('Best Fit')}</p>
        {content}
      </div>
    )
  }

  return content
}
